<template>
  <q-page padding>
    <div class="row col-12 align">
      <p class="text-h5 text-brand-5 text-weight-bold header-title">
        Necessidade de compra ALMOX #{{ dados?.numero }}
      </p>
    </div>

    <section class="column info-section">
      <span
        class="q-mt-sm text-brand-5 text-weight-bold row items-center info-label"
      >
        Criado por:
        <span class="q-ml-sm text-black info-value">
          <span>{{ dados?.usuario_nome }}</span>
        </span>
      </span>
      <span
        class="q-mt-sm text-brand-5 text-weight-bold row items-center info-label"
      >
        Urgência Definida:
        <span class="q-ml-sm text-black info-value">
          <span>{{ dados?.tag }}</span>
        </span>
      </span>
      <span
        class="q-mt-sm text-brand-5 text-weight-bold row items-center info-label"
      >
        Solicitante:
        <span class="q-ml-sm text-black info-value">
          <span>{{ dados?.solicitante_nome }}</span>
        </span>
      </span>
      <span
        class="q-mt-sm text-brand-5 text-weight-bold row items-center info-label"
      >
        Unidade de Controle:
        <span class="q-ml-sm text-black info-value">
          <span
            >{{ dados?.cost_center_code }} ({{ dados?.cost_center_name }})</span
          >
        </span>
      </span>
      <span
        v-if="dados?.cricao_necessidade"
        class="q-mt-sm text-brand-5 text-weight-bold row items-center info-label"
      >
        Criada Em:
        <span class="q-ml-sm text-black info-value">
          <span>
            {{
              dados?.cricao_necessidade
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span
          >
        </span>
      </span>
    </section>

    <p class="text-h6 q-mt-xl table-title">Produtos desta necessidade</p>

    <div class="container">
      <div class="row col-12">
        <q-table
          class="col-12 products-table"
          hide-bottom
          table-header-class="bg-accent text-weight-bold"
          :rows-per-page-options="[0]"
          flat
          :columns="columns"
          :rows="produtos"
        >
          <template #body-cell-remover="props">
            <q-td>
              <q-btn
                icon="sym_o_delete"
                flat
                color="red"
                round
                @click="produtos.splice(props.rowIndex, 1)"
              />
            </q-td>
          </template>
          <template #body-cell-codigo="props">
            <q-td>
              {{ props.row.product_codigo || props.row.codigo }}
            </q-td>
          </template>
        </q-table>
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

// funçao para formatar quantidade (minimo 2 casas decimais, maximo 4)
const formatQuantidade = (value) => {
  if (!value && value !== 0) return "0,00";
  const num = Number(value);
  if (isNaN(num)) return "0,00";
  
  let formatted = num.toFixed(4);

  const parts = formatted.split('.');
  if (parts.length === 2) {
    let decimals = parts[1];
    while (decimals.length > 2 && decimals[decimals.length - 1] === '0') {
      decimals = decimals.slice(0, -1);
    }
    formatted = parts[0] + '.' + decimals;
  }
  
  return formatted.replace('.', ',');
};

const columns = [
  {
    name: "remover",
    label: "Remover",
    align: "left",
    field: "remover",
  },
  {
    name: "responsavel",
    label: "Responsável",
    align: "left",
    field: "responsavel_nome",
  },
  {
    name: "produto",
    label: "Produto",
    align: "left",
    field: "produto_nome",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    field: "product_codigo",
  },
  {
    name: "quantidadeCompra",
    label: "Qtd. de Compra",
    align: "left",
    field: (row) =>
      row.quantidade_necessaria
        ? formatQuantidade(row.quantidade_necessaria)
        : "0,00",
  },
  {
    name: "unidadeMedida",
    label: "Unid. Medida",
    align: "left",
    field: "unidade_medida",
  },
];

export default {
  setup() {
    const route = useRoute();
    const store = useStore();
    const $q = useQuasar();
    const produtos = ref([]);
    const produtosSemReferencia = ref([]);
    const id = route.params.id;
    const dados = ref("");

    const getSemReferencia = async () => {
      try {
        const response = await store.dispatch("compras/getSemReferencia", {
          uuid: id,
          data_inicial: "01/01/2001",
          per_page: 1000,
          associado: 0,
          comprado: 2,
        });

        produtosSemReferencia.value = response.data.data;

        if (!dados.value || Object.keys(dados.value).length === 0) {
          if (produtosSemReferencia.value.length > 0) {
            dados.value = { ...produtosSemReferencia.value[0] };
            if (dados.value?.product_codigo == null) {
              dados.value.product_codigo = "";
            }
          }
        }

        produtos.value = [
          ...produtos.value,
          ...produtosSemReferencia.value.map((item) => ({
            ...item,
            produto_nome: item.descricao || item.produto_nome,
            quantidade_necessaria:
              item.quantidade || item.quantidade_necessaria,
            unidade_medida: item.medida || item.unidade_medida,
          })),
        ];
      } catch (error) {
        $q.notify({
          message: "Erro ao carregar produtos sem referência",
          color: "negative",
        });
      }
    };

    const getDados = async () => {
      try {
        store.dispatch("pdt/hiddenHeader", false);
        const response = await store.dispatch("compras/acompanhar", {
          uuid: id,
        });

        if (response.data?.data?.length > 0) {
          dados.value = response.data.data[0];
          produtos.value = response.data.data;
        }

        await getSemReferencia();
      } catch (error) {
        $q.notify({
          message: "Erro ao carregar dados da necessidade",
          color: "negative",
        });

        await getSemReferencia();
      }
    };

    onMounted(getDados);

    const deletar = async (index) => {
      produtos.value.splice(index, 1);
    };

    return {
      dados,
      getDados,
      produtos,
      deletar,
      columns,
      produtosSemReferencia,
      formatQuantidade,
    };
  },
};
</script>

<style scoped>
.center {
  text-align: center;
}

.table {
  display: table;
  border-collapse: separate;
  border-spacing: 5px;
}

.cell {
  display: table-cell;
  padding: 5px;
  border: 1px solid black;
}

.align {
  align-items: center;
}

.justify-center {
  height: 46px;
  align-items: center;
}

.header-title {
  font-size: 24px !important;
  line-height: 1.3 !important;
}

.info-section {
  font-size: 16px;
}

.info-label {
  font-size: 16px !important;
}

.info-value {
  font-size: 16px !important;
}

.table-title {
  font-size: 18px !important;
}

.products-table :deep(th) {
  font-size: 13px !important;
  padding: 8px 4px !important;
  white-space: normal !important;
  word-wrap: break-word !important;
}

.products-table :deep(td) {
  font-size: 12px !important;
  padding: 6px 4px !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  max-width: 200px;
  overflow-wrap: break-word;
}

@media print {
  .header-title {
    font-size: 22px !important;
    line-height: 1.2 !important;
  }

  .info-section {
    font-size: 14px !important;
  }

  .info-label {
    font-size: 14px !important;
  }

  .info-value {
    font-size: 14px !important;
  }

  .table-title {
    font-size: 16px !important;
  }

  .products-table :deep(th) {
    font-size: 11px !important;
    padding: 6px 3px !important;
  }

  .products-table :deep(td) {
    font-size: 10px !important;
    padding: 4px 3px !important;
    max-width: 180px;
  }

  .detele {
    display: none;
  }
}
</style>
